const getLocationLabel = (location, province) =>
  province ? `${location || ''}, ${province}` : location || '';

const getGroupKeyAndLabel = (load, groupBy) => {
  switch (groupBy) {
    case 'destination': {
      const label = getLocationLabel(load.to, load.toProvince) || 'Sin destino';
      return { key: `destination:${label}`, label };
    }
    case 'origin': {
      const label = getLocationLabel(load.from, load.fromProvince) || 'Sin origen';
      return { key: `origin:${label}`, label };
    }
    case 'product': {
      const label = load.productType || 'Sin producto';
      return { key: `product:${label}`, label };
    }
    default:
      return { key: 'unknown', label: 'Sin agrupar' };
  }
};

/**
 * Groups loads by destination, origin or product.
 * Panel order follows the first appearance of each group in the API list
 * (which is ascending by load date).
 */
const groupLoadsBy = (loads, groupBy) => {
  if (!groupBy || !Array.isArray(loads)) {
    return [];
  }

  const groupsMap = new Map();

  loads.forEach(load => {
    const { key, label } = getGroupKeyAndLabel(load, groupBy);
    if (!groupsMap.has(key)) {
      groupsMap.set(key, { key, label, loads: [] });
    }
    groupsMap.get(key).loads.push(load);
  });

  return Array.from(groupsMap.values());
};

export default groupLoadsBy;
